import React from 'react';
import Select from 'react-select';

class renderMultiSelectSearch extends React.Component {  
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this)
  }

  handleSelect(e) {
    this.props.input.onChange(e)
  }
  render = () => {
    const {
      meta: { touched, error },
      input
    } = this.props;

    return <div>
      <Select
        {...this.props}
        onChange={this.handleSelect}
        value={input.value}
        isMulti
        styles={{
          control: base => ({
            ...base,
            border: `1px solid ${touched && error ? 'red' : '#BABBBD'}`
          })
        }}
      />
      { 
        touched && error 
          ? <span className="field-validation-message">
              {error}
            </span>
          : null
      }
      </div>
  }  
}

export default renderMultiSelectSearch;